import React from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import AgeViewHighJumpResults from 'components/admin/result/AgeViewHighJumpResults';
import EventViewHighJumpResults from 'components/admin/result/EventViewHighJumpResults';
import AgeViewTrackResults from 'components/admin/result/AgeViewTrackResults';
import EventViewTrackResults from 'components/admin/result/EventViewTrackResults';

const Results = ({ isOpenEditPopup = false, isOpenEditEventPopup = false }) => {
  const params = useParams();
  const { clubId, meetId, eventType } = params;
  const isHighJump = eventType === 'High Jump';

  // Event-round route has eventID. Age-view route has athleteAgeGroup.
  if (params.eventID) {
    const Component = isHighJump
      ? EventViewHighJumpResults
      : EventViewTrackResults;
    return (
      <Component
        clubId={clubId}
        meetId={meetId}
        eventType={eventType}
        eventID={params.eventID}
        isOpenEditPopup={isOpenEditPopup}
        isOpenEditEventPopup={isOpenEditEventPopup}
      />
    );
  }

  if (params.athleteAgeGroup) {
    const Component = isHighJump ? AgeViewHighJumpResults : AgeViewTrackResults;
    return (
      <Component
        clubId={clubId}
        meetId={meetId}
        eventType={eventType}
        athleteAgeGroup={params.athleteAgeGroup}
        gender={params.gender}
        roundType={params.roundType}
        isOpenEditPopup={isOpenEditPopup}
      />
    );
  }

  return null;
};

Results.propTypes = {
  isOpenEditPopup: PropTypes.bool,
  isOpenEditEventPopup: PropTypes.bool,
};

export default Results;
